import React from 'react';
import { TextField, TextFieldProps, InputAdornment, Chip } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

type Props = Omit<TextFieldProps, 'type'> & {
  secretPath: string;
  configuredSecrets: string[];
  backendMode: boolean;
};

export function SecretField({
  secretPath,
  configuredSecrets,
  backendMode,
  value,
  helperText,
  ...rest
}: Props) {
  const saved = backendMode && configuredSecrets.includes(secretPath) && !String(value || '').trim();
  const placeholder = saved ? 'Saved securely — enter new value to replace' : undefined;

  return (
    <TextField
      {...rest}
      type="password"
      value={value ?? ''}
      placeholder={placeholder}
      helperText={
        saved ? (
          <>
            {helperText ? `${helperText} · ` : ''}
            Stored in Google Secret Manager
          </>
        ) : (
          helperText
        )
      }
      InputProps={{
        ...rest.InputProps,
        startAdornment: saved ? (
          <InputAdornment position="start">
            <Chip size="small" icon={<LockOutlinedIcon />} label="Saved" color="success" variant="outlined" />
          </InputAdornment>
        ) : (
          rest.InputProps?.startAdornment
        ),
      }}
    />
  );
}
